import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import './BtnSide.css'
import template from './BtnSide.jinja'

const STROKE_OFFSET = 26
const BOTTOM_OFFSET = 50

var BtnSide = Backbone.View.extend({
    el: '.BtnSide',

    initialize () {
        this.$el.addClass('isNotHoverable')

        this.$circles = this.$('.BtnSide-circle')

        this.$circleLeftTop = this.$circles.filter('.BtnSide-circle--leftTop')
        this.$circleRightTop = this.$circles.filter('.BtnSide-circle--rightTop')
        this.$circleLeftBottom = this.$circles.filter('.BtnSide-circle--leftBottom')
        this.$circleRightBottom = this.$circles.filter('.BtnSide-circle--rightBottom')

        $.Velocity.hook(this.$circles, 'opacity', 0)
        $.Velocity.hook(this.$circleLeftTop, 'stroke-dashoffset', STROKE_OFFSET)
        $.Velocity.hook(this.$circleRightTop, 'stroke-dashoffset', STROKE_OFFSET)
        $.Velocity.hook(this.$circleLeftBottom, 'stroke-dashoffset', STROKE_OFFSET)
        $.Velocity.hook(this.$circleRightBottom, 'stroke-dashoffset', STROKE_OFFSET)
    },

    activateSide() {
        let duration = 1000

        $.Velocity.hook(this.$el[0], 'opacity', 1)
        $.Velocity.hook(this.$el[0], 'translateY', 0)

        $.Velocity.animate(this.$el[0], {
            display: 'none',
            opacity: [0, 'easeInQuad'],
            translateY: [-(app.els.$window.height() / 2 - BOTTOM_OFFSET - this.$el.outerHeight() / 2) + 'px', 'easeOutCubic']
        }, {
            duration
        })

        return duration
    },

    deactivateSide() {
        return $.Velocity.animate(this.$el[0], {
            display: 'block',
            opacity: [1, 'easeOutQuad'],
            translateY: [0, 'easeOutQuad']
        }, {
            duration: 1000
        })
    },

    playIn() {
        $.Velocity.animate(this.$circleLeftTop[0], {
            opacity: 1,
            'stroke-dashoffset': 0
        }, {
            duration: 800,
            easing: 'linear'
        })

        $.Velocity.animate(this.$circleRightBottom[0], {
            opacity: 1,
            'stroke-dashoffset': 0
        }, {
            duration: 800,
            easing: 'linear'
        })

        $.Velocity.animate(this.$circleRightTop[0], {
            opacity: 1,
            'stroke-dashoffset': 0
        }, {
            duration: 800,
            easing: 'linear',
            delay: 400
        })

        $.Velocity.animate(this.$circleLeftBottom[0], {
            opacity: 1,
            'stroke-dashoffset': 0
        }, {
            duration: 800,
            easing: 'linear',
            delay: 600
        })
            .then(() => {
                this.$el.removeClass('isNotHoverable')
            })
    },

    playOut() {

    }
})

export default BtnSide


// WEBPACK FOOTER //
// ./assets/app/front/components/BtnSide/BtnSide.js